import React, { useEffect, useState } from 'react'
import './ProductoDetalleExpositor.scss'
import { connect } from 'react-redux';
import { DobleGuion } from './DobleGuion';
import * as _ from 'lodash'
import { useActiveDesactiveSrollBody } from '../hooks/activeDesactivScrollBody';
import ProductoExpositor from './ProductoExpositor';
import { setFormatSelected } from '../actions/index'

const ProductoDetalleExpositor = (props) => {
    const { expositors } = props
    const [showProductComplement, setShowProductComplement] = useState(false)
    const [expositorDetails, setExpositorDetails] = useState(null)
    const [oldStatusFormatSelected, setOldStatusFormatSelected] = useState(false)

    const handleSelectChage = (expositor) => {
        setOldStatusFormatSelected(props.formatSelected)
        setShowProductComplement(true)
        useActiveDesactiveSrollBody(true)
        setExpositorDetails(expositor)
    }

    const handleCloseProductComplement = () => {
        props.setFormatSelected(oldStatusFormatSelected)
        setShowProductComplement(false)
        useActiveDesactiveSrollBody(false)
    }

    return (
        <React.Fragment>
            {
                showProductComplement &&
                <ProductoExpositor product={expositorDetails} clickClose={handleCloseProductComplement} ></ProductoExpositor>
            }
            {
                expositors !== null && expositors.length > 0 &&
                <div className="producto-detalle-expositor">
                    <div className="titulo"><p>Producto en expositor</p> <DobleGuion /></div>
                    <div className="expositors">
                        {expositors.map((expositor, index) => {
                            return (
                                <div className="item" key={index}>
                                    <div className="img"><img src={"/static/imgProducts/" + expositor.Fotografia + "_p.jpg"} onError={(e) => {
                                        e.target.onerror = null
                                        e.target.src = '/static/img/no-imagen-fansa.png'
                                    }} alt="" /></div>
                                    <div className="text-btn">
                                        <div className="text">{expositor.Descripcion}</div>
                                        <div className="btn btn-invert" onClick={() => handleSelectChage(expositor)}>Ver más</div>
                                    </div>
                                </div>
                            )
                        })
                        }

                    </div>
                </div>
            }
        </React.Fragment>
    )
}

const mapDispatchToProps = {
    setFormatSelected
}

const mapStateToProps = state => state

export default connect(mapStateToProps, mapDispatchToProps)(ProductoDetalleExpositor)


